import { useModoConsultaEvaluacion } from '../../../../hooks/useModoConsultaEvaluacion';
import React, { useContext, useState } from 'react';
import { Button, Card, Container, Form } from 'react-bootstrap';
import { addDoc, collection } from 'firebase/firestore';
import Swal from 'sweetalert2';

import { AppContext } from '../../../../Context';
import { db } from '../../../../firebase/firebase';

const preguntasSeleccion = [
    {
        id: 'hechos',
        titulo: '1. ¿Cuáles de las siguientes afirmaciones son claramente hechos?',
        opciones: [
            { id: 'a', etiqueta: 'Ahora se vive mejor que antes.' },
            { id: 'b', etiqueta: 'El crecimiento económico en los últimos años se ha dado a un ritmo del 3.06% anual.' },
            { id: 'c', etiqueta: 'La renta per cápita en los países desarrollados ha crecido a un ritmo de 60%.' },
            { id: 'd', etiqueta: 'La evolución de la renta hace más ricos los países.' }
        ]
    },
    {
        id: 'opiniones',
        titulo: '2. ¿Cuáles de las siguientes oraciones son claramente opiniones?',
        opciones: [
            { id: 'a', etiqueta: 'La falta de equidad es aún más grave en los países en desarrollo.' },
            { id: 'b', etiqueta: 'El 41% de la población no tiene acceso al agua potable.' },
            { id: 'c', etiqueta: 'Algunos datos resultan un verdadero atentado contra la ética y la más básica dignidad humana.' },
            { id: 'd', etiqueta: 'Un tercio de la población vive con menos de un dólar diario.' }
        ]
    },
    {
        id: 'interpretaciones',
        titulo: '3. ¿Cuáles planteamientos son interpretaciones o asociaciones que un lector podría hacer?',
        opciones: [
            { id: 'a', etiqueta: 'Las políticas del Fondo Monetario Internacional están llevando a los países en desarrollo a la quiebra.' },
            { id: 'b', etiqueta: 'El crecimiento económico sostenido se traducirá en el largo plazo en bienestar para todos.' },
            { id: 'c', etiqueta: 'Los problemas económicos de nuestros países son, en mínima parte, consecuencia de la recesión y, en mayor parte, de las políticas neoliberales.' }
        ]
    }
];

const respuestasIniciales = {
    hechos: [],
    opiniones: [],
    interpretaciones: [],
    interpretacionPersonal: '',
    opinionCrecimiento: ''
};

const M15_Ejercicio7 = ({ cerrarModal }) => {
    const { currentUser } = useContext(AppContext);
    const modoConsulta = useModoConsultaEvaluacion();
    const [step, setStep] = useState(1);
    const [enviando, setEnviando] = useState(false);
    const [respuestas, setRespuestas] = useState(respuestasIniciales);

    const alternarOpcion = (grupo, opcion) => {
        setRespuestas(prev => {
            const seleccionadas = prev[grupo].includes(opcion)
                ? prev[grupo].filter(valor => valor !== opcion)
                : [...prev[grupo], opcion];
            return { ...prev, [grupo]: seleccionadas };
        });
    };

    const avanzar = () => {
        const grupo = preguntasSeleccion[step - 1].id;
        if (!modoConsulta && (respuestas[grupo].length === 0)) {
            Swal.fire({
                icon: 'warning',
                title: 'Selecciona una respuesta',
                text: 'Marca al menos una opción antes de continuar.'
            });
            return;
        }
        setStep(prev => prev + 1);
    };

    const enviarResultados = async () => {
        if (modoConsulta) { cerrarModal?.(); return; }

        if (!respuestas.interpretacionPersonal.trim() || !respuestas.opinionCrecimiento.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Respuestas incompletas',
                text: 'Contesta las preguntas 4 y 5 antes de enviar.'
            });
            return;
        }

        setEnviando(true);
        try {
            await addDoc(collection(db, 'evaluaciones'), {
                userId: currentUser.uid,
                nombre: 'Ejercicio 7 - Diferencie hechos y opiniones',
                nivel: 'Avanzado',
                modulo: '15',
                createdAt: new Date(),
                tipo: 'Comprensión e interpretación',
                lectura: 'Desarrollo y pobreza',
                respuestas
            });
            await Swal.fire({
                title: '¡Ejercicio completado!',
                text: 'Tus respuestas se guardaron correctamente.',
                icon: 'success',
                confirmButtonColor: '#198754',
                confirmButtonText: 'Continuar'
            });
            if (cerrarModal) cerrarModal();
        } catch (error) {
            console.error('Error al guardar el ejercicio:', error);
            Swal.fire({ icon: 'error', title: 'No se pudo guardar', text: 'Intenta enviar nuevamente el ejercicio.' });
        } finally {
            setEnviando(false);
        }
    };

    const renderPreguntaSeleccion = pregunta => (
        <div>
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                    <Card.Title>{pregunta.titulo}</Card.Title>
                    <Card.Text className="text-muted">Puedes marcar más de una opción.</Card.Text>
                </Card.Body>
            </Card>
            <Form>
                {pregunta.opciones.map(opcion => (
                    <Form.Check
                        className="mb-3"
                        type="checkbox"
                        id={`${pregunta.id}-${opcion.id}`}
                        name={pregunta.id}
                        key={opcion.id}
                        label={`${opcion.id}. ${opcion.etiqueta}`}
                        checked={respuestas[pregunta.id].includes(opcion.id)}
                        onChange={() => alternarOpcion(pregunta.id, opcion.id)}
                    />
                ))}
            </Form>
            <div className="d-flex justify-content-between mt-4">
                <Button variant="secondary" disabled={step === 1} onClick={() => setStep(prev => prev - 1)}>
                    Atrás
                </Button>
                <Button onClick={avanzar}>Siguiente</Button>
            </div>
        </div>
    );

    return (
        <Container>
            <h3 className="text-center mb-2">Ejercicio 7 - Diferencie hechos y opiniones</h3>
            <p className="text-center text-muted mb-4">Lectura: Desarrollo y pobreza</p>

            {step <= 3 && renderPreguntaSeleccion(preguntasSeleccion[step - 1])}

            {step === 4 && (
                <div>
                    <Card className="mb-4 shadow-sm border-success">
                        <Card.Body>
                            <Card.Title>Interpretación y opinión personal</Card.Title>
                            <Card.Text>Responde con tus propias palabras a partir de la lectura.</Card.Text>
                        </Card.Body>
                    </Card>
                    <Form>
                        <Form.Group className="mb-4">
                            <Form.Label>4. ¿Tiene usted una interpretación diferente? Escríbala aquí:</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={4}
                                name="interpretacionPersonal"
                                value={respuestas.interpretacionPersonal}
                                onChange={event => setRespuestas(prev => ({ ...prev, interpretacionPersonal: event.target.value }))}
                            />
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label>
                                5. Hay quienes afirman que el crecimiento económico sostenido se traduce a largo plazo
                                en desarrollo para todos porque, a mayor rentabilidad, mayor inversión, más producción y
                                mejores ingresos para todos. ¿Usted qué opina?
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                name="opinionCrecimiento"
                                value={respuestas.opinionCrecimiento}
                                onChange={event => setRespuestas(prev => ({ ...prev, opinionCrecimiento: event.target.value }))}
                            />
                        </Form.Group>
                    </Form>
                    <div className="d-flex justify-content-between">
                        <Button variant="secondary" onClick={() => setStep(3)}>Atrás</Button>
                        <Button variant="success" disabled={enviando} onClick={enviarResultados}>
                            {enviando ? 'Guardando…' : 'Finalizar y enviar'}
                        </Button>
                    </div>
                </div>
            )}
        </Container>
    );
};

export default M15_Ejercicio7;
